import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-links-list-item',
  templateUrl: './links-list-item.component.html',
  styleUrls: ['./links-list-item.component.sass'],
})
export class LinksListItemComponent {
  @Input() title = '';
  @Input() link = '';
}
